import type { MenuItem } from '@/types';

/**
 * REST API docs menu
 */
export const restDocs: MenuItem[] = [
  { label: 'Overview', path: '/sdk_ref/rest-api/overview' },
  { label: 'Channel', path: '/sdk_ref/rest-api/channel' },
  { label: 'Room', path: '/sdk_ref/rest-api/room' },
  { label: 'Stream', path: '/sdk_ref/rest-api/stream' },
  { label: 'RTMP', path: '/sdk_ref/rest-api/rtmp-ingest' },
  { label: 'Transformation', path: '/sdk_ref/rest-api/transformation' },
  { label: 'Reporting', path: '/sdk_ref/rest-api/reporting' },
  { label: 'Analytics', path: '/sdk_ref/rest-api/analytics' },
  { label: 'Notification', path: '/sdk_ref/rest-api/notifications' },
  { label: 'Live and On-Demand', path: '/sdk_ref/rest-api/live-and-on-demand' },
];
